module.exports = __webpack_public_path__ + "img/safest-project-cover.14b0df4c.jpg";